import { render, staticRenderFns } from "./All_PrivacyPolicy.vue?vue&type=template&id=490f57b2&scoped=true&"
import script from "./All_PrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./All_PrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./All_PrivacyPolicy.vue?vue&type=style&index=0&id=490f57b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f57b2",
  null
  
)

export default component.exports